import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import Dashboard from "./Dashboard";
import DashboardConsFinal from "./DashboardConsFinal";
import CampaignScreen from "./components/CampaignScreen";
import PendingOrdersScreen from "./components/PendingOrderScreen";
import Catalogo from "./components/Catalogo";
import { CatalogAnalyticsPro, CustomerProfiles } from "./components/Catalogo";
import ClientsScreen from "./components/Clients";
import OrdersScreen from "./components/Orders";
import PendingBillingOrdersScreen from "./components/PedidosPendientes";
import NewClientsScreen from "./components/NewClientsScreen";

import { ChatSourceProvider } from "./context/ChatSourceContext";



import Navbar from "./Navbar";
import NavbarSinLogin from "./NavbarSinLogin";
import NavbarXeroo from "./NavbarXeroo";
import NavbarLeads from "./NavbarXeroo";
import StatsDashboard from "./StatsDashboard";
import FraudCheckScreen from "./components/FraudCheckScreen";

import MayoristaInbox from "./components/MayoristaInbox";
import RobotStockDashboard from "./components/RobotStockDashboard";

import XerooClientLandingCotizador from "./components/Cotizador";
import XerooClientLandingNew3 from "./components/WelcomeNew3";
import XerooClientLandingNew2 from "./components/WelcomeNew2";
import XerooClientLandingNew from "./components/WelcomeNew";
import XerooClientLanding from "./components/Welcome";
import IASearchLanding from "./components/IASearch";
import StatsDailyDashboard from "./dailyConversations";
import { AuthProvider } from "./AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login-charko" element={<Login />} />
                <Route path="/pendingorders/:token" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        <NavbarSinLogin />
                        <PendingOrdersScreen />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/catalogo/:numeroTelefono" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <Catalogo />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/catalogo/showroom/:numeroTelefono" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <Catalogo />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/catalogo" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <Catalogo />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/catalog-analytics" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <CatalogAnalyticsPro />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/profile-analytics" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <CustomerProfiles />
                        <ToastContainer />
                    </div>
                } />

                {/* <Route path="/catalogo/:numeroTelefono" element={<SmartCatalogPro />} /> */}

                <Route path="/propuesta/:slug" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <XerooClientLandingCotizador />
                        <ToastContainer />
                    </div>
                } />

                <Route path="/propuesta" element={
                    <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                        {/* <NavbarSinLogin /> */}
                        <XerooClientLandingCotizador />
                        <ToastContainer />
                    </div>
                } />

                {/* Rutas protegidas */}

                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">
                                    <h2 className="text-2xl font-bold mb-4">Indicadores</h2>

                                    {/* 👇 Compartimos la fuente seleccionada entre Stats y Dashboard */}
                                    <ChatSourceProvider>
                                        <StatsDashboard />
                                        <hr className="my-6" />
                                        <Dashboard />
                                    </ChatSourceProvider>

                                </div>
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/conversations-clients"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">

                                    {/* <h2 className="text-2xl font-bold mb-4">Indicadores</h2> */}
                                    {/* <h2 className="text-2xl font-bold mb-4">Indicadores & Estadísticas</h2> */}
                                    {/* <StatsDashboard /> */}
                                    {/* <StatsDailyDashboard /> */}

                                    {/* <hr className="my-6" /> */}

                                    {/* <h1 className="text-2xl font-bold mb-4">Conversaciones</h1> */}
                                    <DashboardConsFinal />

                                </div>
                                <ToastContainer />
                            </div>

                        </ProtectedRoute>
                    }
                />

                 <Route
                    path="/robot-dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">
                                    <RobotStockDashboard />
                                </div>
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />


                  <Route
                    path="/mayorista-dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">
                                    <MayoristaInbox />
                                </div>
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/campaigns"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <CampaignScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/pendingbillingorders"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <PendingBillingOrdersScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                {/* <Route
                    path="/pendingorders/:id"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <PendingOrdersScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                /> */}
                <Route
                    path="/clients"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <ClientsScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route

                    path="/orders"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <OrdersScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/new-clients"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <NewClientsScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome/newlanding"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome/newlanding2"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew2 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome/newlanding3"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew3 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome/:clientSlug"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLandingNew />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

            </Routes>
        </BrowserRouter>
    );
}


